<template>
  <div
    class="toggle-input"
    :class="{
      'active': value,
      'disabled': disabled
    }"
    @click="updateValue"
  >
    <div class="toggle-value" />
  </div>
</template>

<script>
  export default {
    name: 'BooleanInput',
    data () {
      return {
      }
    },
    props: {
      value: {
        default: false,
        type: Boolean
      },
      disabled: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      updateValue () {
        let self = this
        if (self.disabled !== true) {
          self.$emit('input', !self.value)
        }
      }
    },
    computed: {
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../../uikit';

  .toggle-input {
    box-sizing: border-box;
    height: 25px;
    width: 40px;
    padding: 2px;
    border: 1px solid $secondaryBorderColor;
    border-radius: 13px;
    cursor: pointer;

    .toggle-value {
      height: 19px;
      width: 19px;
      border-radius: 50%;
      transition-duration: 0.2s;
      background-color: $secondaryBorderColor;
    }

    &.active {
      border-color: $pendingBlue;

      .toggle-value {
        margin-left: 15px;
        background-color: $pendingBlue;
      }
    }

    &.disabled {
      border-color: $mediumGreyBackground;

      .toggle-value {
        margin-left: 8px;
        background-color: $primaryBorderColor;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/input-templates/boolean/BooleanInput.vue